import { createBrowserHistory } from 'history';
import promptStore from 'src/view/components/CustomPrompt/store';

export const history = createBrowserHistory({
  // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
  getUserConfirmation(message, callback) {
    const cleanUp = (answer: any) => {
      promptStore.promptSwitch(null, null);
      callback(answer);
    };

    promptStore.promptSwitch(message || null, cleanUp);
  },
});
